// src/services/userService.ts
import api from "../api/axiosClient";

const BASE = "/User";

export const getUsers = async () => {
  const res = await api.get(BASE);
  return res.data;
};

export const getUser = async (id: number) => {
  const res = await api.get(`${BASE}/${id}`);
  return res.data;
};

export const updateUser = async (id: number, data: any) => {
  const res = await api.put(`${BASE}/${id}`, data);
  return res.data;
};

export const deleteUser = async (id: number) => {
  const res = await api.delete(`${BASE}/${id}`);
  return res.data;
};
